module.exports = __webpack_public_path__ + "static/media/  (143).ebf81b8c.jpg";